import { ComponentProps } from 'react'
import { Dropdown, FancyButton, Stack, Text, TextField } from '@ui'
import { useSizeContext } from 'ui/hooks/useSizeContext'

import { SimpleMarkdown } from './SimpleMarkdown'

const NARROW_SIZE = 500

export const MessageCard = (props: {
    title?: string
    subtitle?: string
    children: React.ReactNode
}) => {
    const { title, subtitle, children } = props
    const hasHeader = title || subtitle
    return (
        <Stack padding elevate gap borderRadius="sm">
            {hasHeader ? (
                <Stack gap="paragraph">
                    {title ? (
                        <Text strong color="default">
                            {title}
                        </Text>
                    ) : null}
                    {subtitle ? <SimpleMarkdown>{subtitle}</SimpleMarkdown> : null}
                </Stack>
            ) : null}
            <Stack gap>{children}</Stack>
        </Stack>
    )
}

export const MessageFormInputContainer = ({ children }: { children: React.ReactNode }) => {
    const isNarrow = useSizeContext().lessThan(NARROW_SIZE)
    return (
        <Stack gap="sm" direction={isNarrow ? 'column' : 'row'} flexWrap="wrap">
            {children}
        </Stack>
    )
}

export const MessageFormSelect = (props: ComponentProps<typeof Dropdown>) => {
    const isNarrow = useSizeContext().lessThan(NARROW_SIZE)
    return <Dropdown height="x5" width={isNarrow ? '100%' : undefined} {...props} />
}

export const MessageFormButton = (props: ComponentProps<typeof FancyButton>) => {
    const isNarrow = useSizeContext().lessThan(NARROW_SIZE)
    return <FancyButton noLayout cta compact grow={isNarrow} {...props} />
}

export const MessageFormTextField = (props: ComponentProps<typeof TextField>) => {
    const isNarrow = useSizeContext().lessThan(NARROW_SIZE)
    return (
        <TextField background="level2" height="x5" width={isNarrow ? '100%' : '400'} {...props} />
    )
}
